import * as React from 'react';
import { Show, SimpleShowLayout, TextField, DateField } from 'react-admin';

const PlanShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Plan Name" source="planName" />
      <TextField label="Amount" source="amount" />
      <TextField label="Currency" source="currency" />
      <TextField label="Maximum Page Checker" source="maxPageChecker" />
      <TextField label="Maximum Form Checker" source="maxFormChecker" />
      <TextField label="Maximum SMS" source="maxSms" />
      <TextField label="Maximum WhatsApp" source="maxWhatsapp" />
    </SimpleShowLayout>
  </Show>
);

export default PlanShow;
